export default "__VITE_ASSET__CCRPxjCu__"